/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Recovery_Code_DownloadedInputs */



/**
* | output |
* | --- |
* | "Recovery code downloaded successfully" |
*
* @param {Auth_Recovery_Code_DownloadedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_recovery_code_downloaded = /** @type {((inputs?: Auth_Recovery_Code_DownloadedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Recovery_Code_DownloadedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiederherstellungscode erfolgreich heruntergeladen")
	return /** @type {LocalizedString} */ ("Recovery code downloaded successfully")
});